import { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { homeRoutePath, notFoundRoutePath } from 'core/constants/routes.constants';
import type { IModuleNavigationDetail } from 'core/model/interfaces/module-navigation.interface';
import { useAppSelector } from 'core/store';
import {
  selectAllModulesNavigationByPlatform,
  selectIsModuleNavigationLoading,
} from 'core/store/module-navigation/selectors';

export const isPathAllowed = (path: string, modulesByPlatform: Array<IModuleNavigationDetail>): boolean =>
  modulesByPlatform.some(item => path.startsWith(item.uri)) || path === homeRoutePath;

const RouteGuard = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const isLoadingModuleNavigation = useAppSelector(selectIsModuleNavigationLoading);
  const moduleByPlatform = useAppSelector(selectAllModulesNavigationByPlatform);

  const allowed = useMemo(() => isPathAllowed(currentPath, moduleByPlatform), [currentPath, moduleByPlatform]);

  if (isLoadingModuleNavigation) return null;

  return allowed ? <Outlet /> : <Navigate to={notFoundRoutePath} replace />;
};

export default RouteGuard;
